/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

/**
 * The plan of the organization
 */
export type GetOrganization200OrganizationPlan =
  (typeof GetOrganization200OrganizationPlan)[keyof typeof GetOrganization200OrganizationPlan];

export const GetOrganization200OrganizationPlan = {
  TRIAL: "TRIAL",
  FLEX: "FLEX",
  PRO: "PRO",
  PREMIUM: "PREMIUM",
  CUSTOM: "CUSTOM",
  LEGACY: "LEGACY",
} as const;
